import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=c2c9f900"
import script from "./HowItWorks.vue?vue&type=script&lang=ts"
export * from "./HowItWorks.vue?vue&type=script&lang=ts"
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=c2c9f900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports